import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/plans');

export async function getAllPlans() {
  const response = await apiFetch(`${API_BASE}/`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des plans');
  }
  return response.json();
}

export async function getPlanGrilleData(planId) {
  const response = await apiFetch(`${API_BASE}/${planId}/grille-data`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des données de la grille');
  }
  return response.json();
}

export async function updatePlanStatus(planId, statut) {
  const response = await apiFetch(`${API_BASE}/${planId}/status`, {
    method: 'PATCH',
    auth: true,
    json: true,
    body: JSON.stringify({ statut }),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Mise à jour du statut impossible');
  }
  return response.json();
}

export async function updateGrilleData(planId, payload, statut) {
  const response = await apiFetch(`${API_BASE}/${planId}/grille-data`, {
    method: 'PUT',
    auth: true,
    json: true,
    body: JSON.stringify({ payload, statut }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erreur lors de la mise à jour');
  }
  return response.json();
}
